import {
  NgModule,
  Optional,
  SkipSelf
} from "@angular/core";

import { SharedModule } from "src/app/shared/shared.module";
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { NavigationMenuComponent } from './navigation-menu/navigation-menu.component';
import { BodyComponent } from './body/body.component';
import { DashboardLayoutComponent } from './layout/dashboard-layout.component';
import { PortalLayoutComponent } from './layout/portal-layout.component';
import { RootCssVariablesComponent } from './root-css-variables/root-css-variables.component';
import { UserNotificationComponent } from './user-notification/user-notification.component';
import { MedptAppsMenuComponent } from "./medpt-apps/medpt-apps.component";
import { RaiHeaderComponent } from './rai-header/rai-header.component';

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    NavigationMenuComponent,
    BodyComponent,
    DashboardLayoutComponent,
    PortalLayoutComponent,
    RootCssVariablesComponent,
    UserNotificationComponent,
    MedptAppsMenuComponent,
    RaiHeaderComponent
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    NavigationMenuComponent,
    BodyComponent,
    DashboardLayoutComponent,
    PortalLayoutComponent,
    RootCssVariablesComponent,
    UserNotificationComponent,
    MedptAppsMenuComponent,
    RaiHeaderComponent
  ],
  imports: [
    SharedModule
  ],
  providers: []
})
export class LayoutModule {
  constructor(
    @Optional()
    @SkipSelf()
    parentModule: LayoutModule
  ) {
    if (parentModule) {
      throw new Error("LayoutModule is already loaded. Import it in the AppModule only");
    }
  }
}
